import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './InfoMessage.css'
import Button from '../Button/Button'
import { newlineToBr } from '../../utils/format' 

import FormActions from '../../actions/FormActions'

@CSSModules(styles, { allowMultiple: true })
export default class InfoMessage extends Component {
  static propTypes = {
    instructions: PropTypes.string,
    message: PropTypes.string
  }
  static defaultProps = {
    instructions: '',
    message: ''
  }
  _onClick () {
    FormActions.setShowInfoMessage(false)
  }

  render () {
    const { instructions, message } = this.props
    if (!message) return null
    return (
      <div styleName="infoMessage">
        <div styleName="message">
          <img src={'/static/img/info.png'} styleName="image" />
          {instructions && <div>
            <p dangerouslySetInnerHTML={{ __html: newlineToBr(instructions) }} styleName="instructions" />
            <hr />
          </div>}
          <p dangerouslySetInnerHTML={{ __html: newlineToBr(message) }} styleName="text" />
          <Button
            autoFocus
            onClick={this._onClick.bind(this)}
            text="Jag förstår" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/InfoMessage/InfoMessage.js